var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mx-3 pa-2 overline grey lighten-1"},[_vm._v(_vm._s(_vm.text))])
}]

export { render, staticRenderFns }